import { useClientProposalView } from '../clientQuoteViews';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Quote, Product } from '../types';
import { QuotePreview } from '../components/QuotePreview';
import { GlassCard } from '../components/ui/GlassCard';
import { clientView } from '../clientAccess';
import { Loader2, AlertCircle } from 'lucide-react';

export const ClientQuoteView = () => {
  const { quoteId } = useParams<{ quoteId: string }>();
  const location = useLocation();
  const [quote, setQuote] = useState<Quote | null>(null);
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState<Product[]>([]); 

  useEffect(() => {
    let active = true;
    setLoading(true); setQuote(null);
    if (!quoteId) { setLoading(false); return; }
    clientView(quoteId).then(data => { if(active) { setQuote(data.quote); setProducts(data.products); } })
      .catch(() => { if(active) setQuote(null); }).finally(() => { if(active) setLoading(false); });
    return () => { active=false; };
  }, [quoteId, location.search]);
  useClientProposalView(!loading && quoteId && quote?.id === quoteId ? quoteId : null);
  const handleQuoteUpdate = async (_updated: Quote) => {
    if (!quoteId) return;
    const data=await clientView(quoteId); setQuote(data.quote); setProducts(data.products);
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-24 flex flex-col items-center justify-center">
        <Loader2 size={48} className="text-brand-neonBlue animate-spin mb-4" />
        <p className="text-slate-400">Retrieving proposal...</p>
      </div>
    );
  }

  if (!quote) {
    return (
      <div className="min-h-screen pt-24 flex items-center justify-center px-4">
        <GlassCard className="max-w-md text-center p-8">
          <AlertCircle size={48} className="text-red-400 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-white mb-2">Quote Not Found</h1>
          <p className="text-slate-400 mb-6">
            This quote link may have expired or is invalid. Please contact the QuikPix team for assistance.
          </p>
          <Link to="/" className="text-brand-neonBlue hover:text-white font-bold">
            Return to Home
          </Link>
        </GlassCard>
      </div>
    );
  }

  return (
    <div className="quote-public-view min-h-screen pt-24 pb-12 px-4">
      <QuotePreview 
        quote={quote} 
        onUpdate={handleQuoteUpdate} 
        onBack={() => {}} 
        isPublicView={true}
        availableProducts={products} 
      />
    </div>
  );
};
